"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRootStore = exports.createRootStore = exports.rootStoreRef = exports.RootStore = exports.BaseStore = void 0;
var mobx_1 = require("mobx");
var mobx_keystone_1 = require("mobx-keystone");
var load_1 = require("../constants/load");
var location_1 = require("../constants/location");
var api = __importStar(require("../services/api"));
var firebase_1 = __importDefault(require("../services/firebase"));
var tokenService = __importStar(require("../services/token"));
var models_1 = require("../utils/models");
var Accessorial_1 = require("./Accessorial");
var AdditionalBillingLeg_1 = require("./AdditionalBillingLeg");
var Billing_1 = require("./Billing");
var DriverLoadReport_1 = require("./DriverLoadReport");
var DriverSchedule_1 = require("./DriverSchedule");
var EquipmentDamageReport_1 = require("./EquipmentDamageReport");
var Load_1 = require("./Load");
var LoadQuery_1 = require("./LoadQuery");
var LoadTableRow_1 = require("./LoadTableRow");
var LoadType_1 = require("./LoadType");
var LoadUnit_1 = require("./LoadUnit");
var Location_1 = require("./Location");
var Manifest_1 = require("./Manifest");
var Notification_1 = require("./Notification");
var OrderLeg_1 = require("./OrderLeg");
var Organization_1 = require("./Organization");
var PhotoIssueReport_1 = require("./PhotoIssueReport");
var ScheduleRow_1 = require("./ScheduleRow");
var SocialAccount_1 = require("./SocialAccount");
var Truck_1 = require("./Truck");
var User_1 = require("./User");
var VehicleType_1 = require("./VehicleType");
var BaseStore = /** @class */ (function (_super) {
    __extends(BaseStore, _super);
    function BaseStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseStore = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/BaseStore')
    ], BaseStore);
    return BaseStore;
}((0, mobx_keystone_1.Model)({
    token: (0, mobx_keystone_1.prop)(),
})));
exports.BaseStore = BaseStore;
var RootStore = /** @class */ (function (_super) {
    __extends(RootStore, _super);
    function RootStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return 'RootStore'; };
        //Will be deleted
        _this.getLoads = function (statuses, query) {
            var q = query ? query.toLowerCase() : null;
            var me = _this.me && _this.me.maybeCurrent;
            var queryLocation = function (locationRef, q) {
                if (!locationRef.isValid)
                    return false;
                var location = locationRef.current;
                return (location.name.toLowerCase().includes(q) ||
                    location.fullAddress.toLowerCase().includes(q));
            };
            var queryUser = function (userRef, q) {
                if (!userRef || !userRef.isValid)
                    return false;
                var user = userRef.current;
                return user.fullName.toLowerCase().includes(q);
            };
            return function (loads) {
                return loads.filter(function (load) {
                    if (statuses && !statuses.includes(load.status)) {
                        return false;
                    }
                    if (load.driver && load.driver.maybeCurrent !== me) {
                        return false;
                    }
                    return (!q ||
                        "".concat(load.id).includes(q) ||
                        (load.pickupLocation && queryLocation(load.pickupLocation, q)) ||
                        (load.dropoffLocation && queryLocation(load.dropoffLocation, q)) ||
                        queryUser(load.shipper, q) ||
                        queryUser(load.receiver, q) ||
                        queryUser(load.dispatcher, q));
                });
            };
        };
        _this.getOrderLegs = function (statuses, query) {
            var q = query ? query.toLowerCase() : null;
            var me = _this.me && _this.me.maybeCurrent;
            var queryLocation = function (locationRef, q) {
                if (!locationRef.isValid)
                    return false;
                var location = locationRef.current;
                return (location.name.toLowerCase().includes(q) ||
                    location.fullAddress.toLowerCase().includes(q));
            };
            var queryUser = function (userRef, q) {
                if (!userRef || !userRef.isValid)
                    return false;
                var user = userRef.current;
                return user.fullName.toLowerCase().includes(q);
            };
            return function (loads) {
                return loads.filter(function (load) {
                    if (statuses && !statuses.includes(load.status)) {
                        return false;
                    }
                    if (load.driver && load.driver.maybeCurrent !== me) {
                        return false;
                    }
                    return (!q ||
                        "".concat(load.id).includes(q) ||
                        (load.pickupLocation && queryLocation(load.pickupLocation, q)) ||
                        (load.dropoffLocation && queryLocation(load.dropoffLocation, q)) ||
                        queryUser(load.shipper, q) ||
                        queryUser(load.receiver, q) ||
                        queryUser(load.dispatcher, q));
                });
            };
        };
        _this.getScheduleRowInOrderLeg = function (orderLeg, isPickup, onPreview) {
            var scheduleRow = onPreview
                ? Array.from(_this.proposedDriverScheduleRows.values()).find(function (row) {
                    return isPickup
                        ? row.proposedPickupStops.includes(Number(orderLeg.pickup.id))
                        : row.proposedDropoffStops.includes(Number(orderLeg.dropoff.id));
                })
                : Array.from(_this.driverScheduleRows.values()).find(function (row) {
                    return isPickup
                        ? row.proposedPickupStops.includes(Number(orderLeg.pickup.id))
                        : row.proposedDropoffStops.includes(Number(orderLeg.dropoff.id));
                });
            return scheduleRow;
        };
        _this.getOrderLegsInStop = function (scheduleRow, proposedScheduleView) {
            var pickupOrders = Array.from(_this.orderlegs.values()).filter(function (load) {
                return scheduleRow.pickupStops.includes(Number(load.pickup.id));
            });
            var dropoffOrders = Array.from(_this.orderlegs.values()).filter(function (load) {
                return scheduleRow.dropoffStops.includes(Number(load.dropoff.id));
            });
            if (!proposedScheduleView) {
                return __spreadArray(__spreadArray([], __read(pickupOrders), false), __read(dropoffOrders), false);
            }
            var proposedPickupStops = scheduleRow.proposedPickupStops.filter(function (stop) { return !scheduleRow.pickupStops.includes(stop); });
            var proposedDropoffStops = scheduleRow.proposedDropoffStops.filter(function (stop) { return !scheduleRow.dropoffStops.includes(stop); });
            var proposedPickupOrders = Array.from(_this.orderlegs.values()).filter(function (load) {
                return __spreadArray([], __read(proposedPickupStops), false).includes(Number(load.pickup.id));
            });
            var proposedDropoffOrders = Array.from(_this.orderlegs.values()).filter(function (load) {
                return __spreadArray([], __read(proposedDropoffStops), false).includes(Number(load.dropoff.id));
            });
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(pickupOrders), false), __read(dropoffOrders), false), __read(proposedPickupOrders), false), __read(proposedDropoffOrders), false);
        };
        _this.load = (0, mobx_keystone_1._async)(function () {
            var _a, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        this.loaded = false;
                        _a = this;
                        return [4 /*yield*/, tokenService.getAuthToken()];
                    case 1:
                        _a.token = _b.sent();
                        if (!this.token) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.fetchMe()];
                    case 2:
                        error = (_b.sent()).error;
                        if (!error) return [3 /*break*/, 4];
                        this.loading = false;
                        return [4 /*yield*/, this.logout()];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, this.updateLastActivity()];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.verifyFirebaseToken()];
                    case 6:
                        _b.sent();
                        console.log('[DEBUG] Loaded');
                        _b.label = 7;
                    case 7: return [4 /*yield*/, this.getGeofenceRadius()];
                    case 8:
                        _b.sent();
                        this.loaded = true;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
        _this.storeToken = (0, mobx_keystone_1._async)(function (token, firebaseToken) {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.token = token;
                        this.firebaseToken = firebaseToken;
                        return [4 /*yield*/, tokenService.setAuthToken(token)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, tokenService.setFirebaseToken(firebaseToken)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
        _this.removeToken = (0, mobx_keystone_1._async)(function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.token = undefined;
                        this.firebaseToken = undefined;
                        this.me = undefined;
                        return [4 /*yield*/, tokenService.removeAuthToken()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, tokenService.removeFirebaseToken()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
        _this.signup = (0, mobx_keystone_1._async)(function (data) {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.signup(data)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_1)];
                    case 3: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.validateOrganizationId = (0, mobx_keystone_1._async)(function (data) {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.validateOrganizationId(data)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_2)];
                    case 3: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.sendTwilioCode = (0, mobx_keystone_1._async)(function (data) {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.sendTwilioCode(data)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_3)];
                    case 3: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.verifyTwilioCode = (0, mobx_keystone_1._async)(function (data) {
            var status_1, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.verifyTwilioCode(data)];
                    case 1:
                        status_1 = (_a.sent()).response.entities.status;
                        return [2 /*return*/, { ok: true, status: status_1 }];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
        _this.login = (0, mobx_keystone_1._async)(function (data, callback) {
            var _a, token, firebaseToken, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loaded = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, api.login(data)];
                    case 2:
                        _a = (_b.sent()).response.entities, token = _a.token, firebaseToken = _a.firebaseToken;
                        return [4 /*yield*/, this.storeToken(token, firebaseToken)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_5 = _b.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_5)];
                    case 5:
                        if (!callback) return [3 /*break*/, 7];
                        return [4 /*yield*/, callback()];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.load()];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        this.loaded = true;
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.loginWithFacebook = (0, mobx_keystone_1._async)(function (accessToken) {
            var _a, token, firebaseToken, error_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, api.loginWithFacebook(accessToken)];
                    case 1:
                        _a = (_b.sent()).response.entities, token = _a.token, firebaseToken = _a.firebaseToken;
                        return [4 /*yield*/, this.storeToken(token, firebaseToken)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _b.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_6)];
                    case 4: return [4 /*yield*/, this.fetchMe()];
                    case 5:
                        _b.sent();
                        this.loaded = true;
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.loginWithTwitter = (0, mobx_keystone_1._async)(function (accessToken, tokenSecret) {
            var _a, token, firebaseToken, error_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, api.loginWithTwitter(accessToken, tokenSecret)];
                    case 1:
                        _a = (_b.sent()).response.entities, token = _a.token, firebaseToken = _a.firebaseToken;
                        return [4 /*yield*/, this.storeToken(token, firebaseToken)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _b.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_7)];
                    case 4: return [4 /*yield*/, this.fetchMe()];
                    case 5:
                        _b.sent();
                        this.loaded = true;
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.loginWithGoogle = (0, mobx_keystone_1._async)(function (accessToken) {
            var _a, token, firebaseToken, error_8;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, api.loginWithGoogle(accessToken)];
                    case 1:
                        _a = (_b.sent()).response.entities, token = _a.token, firebaseToken = _a.firebaseToken;
                        return [4 /*yield*/, this.storeToken(token, firebaseToken)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _b.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_8)];
                    case 4: return [4 /*yield*/, this.fetchMe()];
                    case 5:
                        _b.sent();
                        this.loaded = true;
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchSocialAccounts = (0, mobx_keystone_1._async)(function () {
            var entities, error_9, entities_1, entities_1_1, data, socialAccount, socialAccount;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchSocialAccounts(this.token)];
                    case 1:
                        (entities = (_b.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_9 = _b.sent();
                        console.log('[DEBUG] error', error_9);
                        return [2 /*return*/, (0, models_1.getError)(error_9)];
                    case 3:
                        try {
                            for (entities_1 = __values(entities), entities_1_1 = entities_1.next(); !entities_1_1.done; entities_1_1 = entities_1.next()) {
                                data = entities_1_1.value;
                                if (this.socialAccounts.has("".concat(data.id))) {
                                    socialAccount = this.socialAccounts.get("".concat(data.id));
                                    if (socialAccount) {
                                        socialAccount.update(data);
                                    }
                                }
                                else {
                                    socialAccount = new SocialAccount_1.SocialAccount(data);
                                    this.socialAccounts.set("".concat(socialAccount.id), socialAccount);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (entities_1_1 && !entities_1_1.done && (_a = entities_1.return)) _a.call(entities_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.connectFacebook = (0, mobx_keystone_1._async)(function (accessToken) {
            var error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.connectFacebook(this.token, accessToken)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_10 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_10)];
                    case 3: return [4 /*yield*/, this.fetchSocialAccounts()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.connectTwitter = (0, mobx_keystone_1._async)(function (accessToken, tokenSecret) {
            var error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.connectTwitter(this.token, accessToken, tokenSecret)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_11 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_11)];
                    case 3: return [4 /*yield*/, this.fetchSocialAccounts()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.connectGoogle = (0, mobx_keystone_1._async)(function (accessToken) {
            var error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.connectGoogle(this.token, accessToken)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_12 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_12)];
                    case 3: return [4 /*yield*/, this.fetchSocialAccounts()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.verifyFirebaseToken = (0, mobx_keystone_1._async)(function () {
            var _a, error_13, firebaseToken, error_14, error_15;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, tokenService.getFirebaseToken()];
                    case 1:
                        _a.firebaseToken = _b.sent();
                        if (!this.firebaseToken) return [3 /*break*/, 8];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 7]);
                        return [4 /*yield*/, firebase_1.default.login(this.firebaseToken)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        error_13 = _b.sent();
                        return [4 /*yield*/, tokenService.removeFirebaseToken()];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.verifyFirebaseToken()];
                    case 6: return [2 /*return*/, _b.sent()];
                    case 7: return [2 /*return*/, (0, models_1.getSuccess)()];
                    case 8:
                        if (!this.token) return [3 /*break*/, 19];
                        _b.label = 9;
                    case 9:
                        _b.trys.push([9, 12, , 14]);
                        return [4 /*yield*/, api.firebaseToken(this.token)];
                    case 10:
                        firebaseToken = (_b.sent()).response.entities.firebaseToken;
                        return [4 /*yield*/, tokenService.setFirebaseToken(firebaseToken)];
                    case 11:
                        _b.sent();
                        this.firebaseToken = firebaseToken;
                        return [3 /*break*/, 14];
                    case 12:
                        error_14 = _b.sent();
                        console.log('[DEBUG] error', { error: error_14 });
                        return [4 /*yield*/, this.logout()];
                    case 13:
                        _b.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_14)];
                    case 14:
                        _b.trys.push([14, 16, , 18]);
                        return [4 /*yield*/, firebase_1.default.login(this.firebaseToken)];
                    case 15:
                        _b.sent();
                        return [3 /*break*/, 18];
                    case 16:
                        error_15 = _b.sent();
                        console.log('[DEBUG] error', { error: error_15 });
                        return [4 /*yield*/, this.logout()];
                    case 17:
                        _b.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_15)];
                    case 18: return [2 /*return*/, (0, models_1.getSuccess)()];
                    case 19: return [2 /*return*/, (0, models_1.getError)(new Error('invalid firebase token'))];
                }
            });
        });
        _this.logout = (0, mobx_keystone_1._async)(function () {
            var error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!this.pushNotificationToken) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.removeDeviceToken({ token: this.pushNotificationToken })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, api.logout(this.token)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_16 = _a.sent();
                        console.log('[DEBUG] error', { error: error_16 });
                        return [3 /*break*/, 5];
                    case 5: return [4 /*yield*/, this.reset()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
        _this.changePassword = (0, mobx_keystone_1._async)(function (data) {
            var error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[DEBUG] change password request');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.changePassword(this.token, data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_17 = _a.sent();
                        console.log('[DEBUG] error', { error: error_17 });
                        return [2 /*return*/, (0, models_1.getError)(error_17)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.resetPasswordRequest = (0, mobx_keystone_1._async)(function (data) {
            var error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[DUBUG] reset password request');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.resetPasswordRequest(data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_18 = _a.sent();
                        console.log('[DEBUG] error', { error: error_18 });
                        return [2 /*return*/, (0, models_1.getError)(error_18)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.resetPasswordConfirm = (0, mobx_keystone_1._async)(function (data, callback) {
            var response, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[DEBUG] reset password confirm');
                        this.loaded = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        console.log('[DEBUG] data for reset password confirm', data);
                        return [4 /*yield*/, api.resetPasswordConfirm(data)];
                    case 2:
                        response = _a.sent();
                        console.log('[DEBUG] reset password confirm response:', response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_19 = _a.sent();
                        console.log('[DEBUG ERROR]', error_19);
                        return [2 /*return*/, (0, models_1.getError)(error_19)];
                    case 4:
                        this.loaded = true;
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchLoad = (0, mobx_keystone_1._async)(function (loadID) {
            var load, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchLoad(this.token, loadID)];
                    case 1:
                        (load = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_20 = _a.sent();
                        console.log('[DEBUG] error', error_20);
                        return [2 /*return*/, null];
                    case 3:
                        this.setLoad(load);
                        return [2 /*return*/, load];
                }
            });
        });
        _this.fetchOrderLeg = (0, mobx_keystone_1._async)(function (loadID) {
            var load, error_21, manifest, orderData, orderLeg, oldManifest, newManifest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchOrderLeg(this.token, loadID)];
                    case 1:
                        (load = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_21 = _a.sent();
                        console.log('[DEBUG] error', error_21);
                        return [2 /*return*/, null];
                    case 3:
                        manifest = load.manifest, orderData = load.orderData, orderLeg = __rest(load, ["manifest", "orderData"]);
                        if (manifest) {
                            if (this.manifests.has("".concat(manifest.id))) {
                                oldManifest = this.manifests.get("".concat(manifest.id));
                                if (oldManifest) {
                                    oldManifest.update(manifest);
                                }
                            }
                            else {
                                newManifest = Manifest_1.Manifest.create(this, manifest);
                                if (newManifest) {
                                    this.manifests.set("".concat(newManifest.id), newManifest);
                                }
                            }
                        }
                        if (orderData) {
                            this.setLoad(orderData);
                        }
                        this.setOrderLegs(orderLeg);
                        this.loaded = true;
                        return [2 /*return*/, load];
                }
            });
        });
        _this.fetchLoadByManifestLinkId = (0, mobx_keystone_1._async)(function (manifestLinkId, resetManifestFirst) {
            var load, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (resetManifestFirst) {
                            this.manifestLinkId = undefined;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLoadByManifestLinkId(this.token, manifestLinkId)];
                    case 2:
                        (load = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_22 = _a.sent();
                        console.log('[DEBUG] error', error_22);
                        this.loaded = true;
                        return [2 /*return*/, null];
                    case 4:
                        this.manifestLinkId = load.manifestLinkId;
                        // this.setLoad(load);
                        this.loaded = true;
                        return [2 /*return*/, load];
                }
            });
        });
        _this.fetchOrderLegByOrderLegLinkId = (0, mobx_keystone_1._async)(function (orderLegLinkId, resetManifestFirst, ignoreOrderData) {
            var load, error_23, manifest, orderData, orderLeg, oldManifest, newManifest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (resetManifestFirst) {
                            this.orderLegLinkId = undefined;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchOrderLegByOrderLegLinkId(this.token, orderLegLinkId)];
                    case 2:
                        (load = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_23 = _a.sent();
                        console.log('[DEBUG] error', error_23);
                        this.loaded = true;
                        return [2 /*return*/, null];
                    case 4:
                        manifest = load.manifest, orderData = load.orderData, orderLeg = __rest(load, ["manifest", "orderData"]);
                        if (manifest && !ignoreOrderData) {
                            if (this.manifests.has("".concat(manifest.id))) {
                                oldManifest = this.manifests.get("".concat(manifest.id));
                                if (oldManifest) {
                                    oldManifest.update(manifest);
                                }
                            }
                            else {
                                newManifest = Manifest_1.Manifest.create(this, manifest);
                                if (newManifest) {
                                    this.manifests.set("".concat(newManifest.id), newManifest);
                                }
                            }
                        }
                        if (orderData && !ignoreOrderData) {
                            this.setLoad(orderData);
                        }
                        if (!ignoreOrderData) {
                            this.setOrderLegs(orderLeg);
                        }
                        this.orderLegLinkId = load.orderLegLinkId;
                        this.loaded = true;
                        return [2 /*return*/, load];
                }
            });
        });
        _this.fetchOrderLegByBillOfLading = (0, mobx_keystone_1._async)(function (billOfLading, resetManifestFirst, ignoreOrderData) {
            var load, error_24, manifest, orderData, orderLeg, oldManifest, newManifest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (resetManifestFirst) {
                            this.orderLegLinkId = undefined;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchOrderLegByBillOfLading(this.token, billOfLading)];
                    case 2:
                        (load = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_24 = _a.sent();
                        console.log('[DEBUG] error', error_24);
                        this.loaded = true;
                        return [2 /*return*/, null];
                    case 4:
                        manifest = load.manifest, orderData = load.orderData, orderLeg = __rest(load, ["manifest", "orderData"]);
                        if (manifest && !ignoreOrderData) {
                            if (this.manifests.has("".concat(manifest.id))) {
                                oldManifest = this.manifests.get("".concat(manifest.id));
                                if (oldManifest) {
                                    oldManifest.update(manifest);
                                }
                            }
                            else {
                                newManifest = Manifest_1.Manifest.create(this, manifest);
                                if (newManifest) {
                                    this.manifests.set("".concat(newManifest.id), newManifest);
                                }
                            }
                        }
                        if (orderData && !ignoreOrderData) {
                            this.setLoad(orderData);
                        }
                        if (!ignoreOrderData) {
                            this.setOrderLegs(orderLeg);
                        }
                        this.orderLegLinkId = load.orderLegLinkId;
                        this.loaded = true;
                        return [2 /*return*/, load];
                }
            });
        });
        _this.fetchAllOrderLegByOrderLegLinkId = (0, mobx_keystone_1._async)(function (orderLegLinkId) {
            var load, error_25, load_2, load_2_1, data, manifest, orderData, orderLeg, oldManifest, newManifest;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchAllOrderLegByOrderLegLinkId(this.token, orderLegLinkId)];
                    case 1:
                        (load = (_b.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_25 = _b.sent();
                        console.log('[DEBUG] error', error_25);
                        this.loaded = true;
                        return [2 /*return*/, null];
                    case 3:
                        try {
                            for (load_2 = __values(load), load_2_1 = load_2.next(); !load_2_1.done; load_2_1 = load_2.next()) {
                                data = load_2_1.value;
                                manifest = data.manifest, orderData = data.orderData, orderLeg = __rest(data, ["manifest", "orderData"]);
                                if (manifest) {
                                    if (this.manifests.has("".concat(manifest.id))) {
                                        oldManifest = this.manifests.get("".concat(manifest.id));
                                        if (oldManifest) {
                                            oldManifest.update(manifest);
                                        }
                                    }
                                    else {
                                        newManifest = Manifest_1.Manifest.create(this, manifest);
                                        if (newManifest) {
                                            this.manifests.set("".concat(newManifest.id), newManifest);
                                        }
                                    }
                                }
                                if (orderData) {
                                    this.setLoad(orderData);
                                }
                                this.setOrderLegs(orderLeg);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (load_2_1 && !load_2_1.done && (_a = load_2.return)) _a.call(load_2);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/, load];
                }
            });
        });
        _this.fetchAllOrderLegBillingLegByOrderLegLinkId = (0, mobx_keystone_1._async)(function (orderLegLinkId) {
            var responseData, error_26, _a, _b, orderLegs, _c, additionalBillingLegs, orderLegs_1, orderLegs_1_1, data, manifest, orderData, orderLeg, additionalBillingLegs_1, additionalBillingLegs_1_1, addBilling;
            var e_3, _d, e_4, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchAllOrderLegBillingLegByOrderLegLinkId(this.token, orderLegLinkId)];
                    case 1:
                        (responseData = (_f.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_26 = _f.sent();
                        console.log('[DEBUG] error', error_26);
                        this.loaded = true;
                        return [2 /*return*/, null];
                    case 3:
                        _a = responseData || {}, _b = _a.orderLegs, orderLegs = _b === void 0 ? [] : _b, _c = _a.additionalBillingLegs, additionalBillingLegs = _c === void 0 ? [] : _c;
                        try {
                            // Process order legs
                            for (orderLegs_1 = __values(orderLegs), orderLegs_1_1 = orderLegs_1.next(); !orderLegs_1_1.done; orderLegs_1_1 = orderLegs_1.next()) {
                                data = orderLegs_1_1.value;
                                manifest = data.manifest, orderData = data.orderData, orderLeg = __rest(data, ["manifest", "orderData"]);
                                if (manifest)
                                    this.setManifest(manifest);
                                if (orderData)
                                    this.setLoad(orderData);
                                this.setOrderLegs(orderLeg);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (orderLegs_1_1 && !orderLegs_1_1.done && (_d = orderLegs_1.return)) _d.call(orderLegs_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        try {
                            // Process additional billing legs
                            for (additionalBillingLegs_1 = __values(additionalBillingLegs), additionalBillingLegs_1_1 = additionalBillingLegs_1.next(); !additionalBillingLegs_1_1.done; additionalBillingLegs_1_1 = additionalBillingLegs_1.next()) {
                                addBilling = additionalBillingLegs_1_1.value;
                                this.setAdditionalBillingLeg(addBilling);
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (additionalBillingLegs_1_1 && !additionalBillingLegs_1_1.done && (_e = additionalBillingLegs_1.return)) _e.call(additionalBillingLegs_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        return [2 /*return*/, responseData];
                }
            });
        });
        _this.fetchMe = (0, mobx_keystone_1._async)(function () {
            var entities, error_27, user, nextUrl, hasNext;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchMe(this.token)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_27 = _a.sent();
                        console.log('[DEBUG] error', error_27);
                        return [2 /*return*/, { error: error_27 }];
                    case 3:
                        user = new User_1.User(entities);
                        this.users.set(user.username, user);
                        this.me = (0, User_1.userRef)(user.username);
                        return [4 /*yield*/, this.fetchLoadTypes()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLoadUnits()];
                    case 5:
                        _a.sent();
                        if (!(this.me.current.isDispatcher || this.me.current.isBroker)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.fetchTerminalLocations()];
                    case 6:
                        _a.sent();
                        if (!entities.organization) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.fetchOrganization(Number(entities.organization))];
                    case 7:
                        _a.sent();
                        this.me.current.organization = (0, Organization_1.organizationRef)(Number(entities.organization).toString());
                        _a.label = 8;
                    case 8:
                        nextUrl = '';
                        _a.label = 9;
                    case 9:
                        if (!true) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.fetchDrivers(nextUrl)];
                    case 10:
                        hasNext = _a.sent();
                        if (!hasNext) {
                            return [3 /*break*/, 11];
                        }
                        nextUrl = hasNext;
                        return [3 /*break*/, 9];
                    case 11: return [2 /*return*/, { user: user }];
                }
            });
        });
        _this.updateMe = (0, mobx_keystone_1._async)(function (data) {
            var entities, error_28;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.me || !this.me.isValid || !this.token) {
                            return [2 /*return*/, (0, models_1.getSuccess)()];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.updateMe(this.token, data)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_28 = _a.sent();
                        console.log('[DEBUG] error', error_28);
                        return [2 /*return*/, (0, models_1.getError)(error_28)];
                    case 4:
                        this.me.current.update(entities);
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.updateMePhoto = (0, mobx_keystone_1._async)(function (photo) {
            var entities, error_29;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.me || !this.me.isValid || !this.token) {
                            return [2 /*return*/, (0, models_1.getSuccess)()];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.updateMePhoto(this.token, photo)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_29 = _a.sent();
                        console.warn('[DEBUG] error', error_29);
                        return [2 /*return*/, (0, models_1.getError)(error_29)];
                    case 4:
                        this.me.current.update(entities);
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.registerDriverDeviceToken = (0, mobx_keystone_1._async)(function (data) {
            var response, error_30;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.me || !this.me.isValid || !this.token) {
                            return [2 /*return*/];
                            // return getSuccess();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.registerDriverDeviceToken(this.token, data)];
                    case 2:
                        (response = (_a.sent()).response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_30 = _a.sent();
                        console.warn('[DEBUG] error', error_30);
                        return [2 /*return*/, (0, models_1.getError)(error_30)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.removeDeviceToken = (0, mobx_keystone_1._async)(function (data) {
            var error_31;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.removeDriverDeviceToken(this.token, data)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_31 = _a.sent();
                        console.warn('[DEBUG] error', error_31);
                        return [2 /*return*/, (0, models_1.getError)(error_31)];
                    case 3: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.getLatestAppVersion = (0, mobx_keystone_1._async)(function () {
            var response, error_32;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.getLatestAppVersion()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_32 = _a.sent();
                        console.warn('[DEBUG] error', error_32);
                        return [2 /*return*/, (0, models_1.getError)(error_32)];
                    case 3: return [2 /*return*/];
                }
            });
        });
        _this.updateLastActivity = (0, mobx_keystone_1._async)(function () {
            var response, error_33;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.updateLastActivity(this.token)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_33 = _a.sent();
                        console.warn('[DEBUG] error', error_33);
                        return [2 /*return*/, (0, models_1.getError)(error_33)];
                    case 3: return [2 /*return*/];
                }
            });
        });
        _this.getGeofenceRadius = (0, mobx_keystone_1._async)(function () {
            var entities, error_34;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.getGeofenceRadius()];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_34 = _a.sent();
                        console.log('[DEBUG] error', error_34);
                        return [2 /*return*/, (0, models_1.getError)(error_34)];
                    case 3:
                        if (entities.radius) {
                            this.setGeofenceRadius(entities.radius);
                        }
                        return [2 /*return*/];
                }
            });
        });
        _this.updateScanCount = (0, mobx_keystone_1._async)(function (data) {
            var error_35;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.me || !this.me.isValid || !this.token) {
                            console.log('not logged in');
                            return [2 /*return*/];
                            // return getSuccess();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.updateScanCount(this.token, data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_35 = _a.sent();
                        console.warn('[DEBUG] error', error_35);
                        return [2 /*return*/, (0, models_1.getError)(error_35)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.validateToken = (0, mobx_keystone_1._async)(function () {
            var error_36;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.me || !this.me.isValid || !this.token) {
                            return [2 /*return*/];
                            // return getSuccess();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.validateToken(this.token)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_36 = _a.sent();
                        console.warn('[DEBUG] error', error_36);
                        return [2 /*return*/, (0, models_1.getError)(error_36)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchLoads = (0, mobx_keystone_1._async)(function (query, statuses, url, replace) {
            var entities, error_37, next, loads;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = {
                            next: null,
                            results: [],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLoads(this.token, (0, LoadQuery_1.toAPI)(__assign({ offset: '0', status__in: statuses }, query)), url)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_37 = _a.sent();
                        console.log('[DEBUG] error', error_37);
                        return [3 /*break*/, 4];
                    case 4:
                        next = entities.next, loads = entities.results;
                        if (replace) {
                            this.loads.clear();
                        }
                        // This will pase the `this` to setLoad as well.
                        return [2 /*return*/, {
                                loads: loads.map(function (data) { return _this.setLoad(data); }),
                                next: next,
                            }];
                }
            });
        });
        _this.fetchActiveDriverSchedule = (0, mobx_keystone_1._async)(function (init) {
            var entities, forceInit, error_38, initialDriverSchedule_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        forceInit = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchActiveDriverSchedule(this.token)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_38 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_38)];
                    case 4:
                        if (!this.currentDate || this.currentDate !== new Date().toDateString()) {
                            this.currentDate = new Date().toDateString();
                            forceInit = true;
                        }
                        if (init || forceInit) {
                            this.driverScheduleRows.clear();
                            this.proposedDriverScheduleRows.clear();
                            initialDriverSchedule_1 = this.setDriverSchedule(__assign(__assign({}, entities), { rows: [], hasProposedSchedule: false }));
                            if (entities.rows) {
                                entities.rows.forEach(function (row) {
                                    if (!!row.proposedPickupStops.length ||
                                        row.proposedDropoffStops.length) {
                                        var newRow = ScheduleRow_1.ScheduleRow.create(_this, row, true);
                                        if (newRow) {
                                            _this.driverScheduleRows.set("".concat(newRow.id), newRow);
                                            initialDriverSchedule_1.rows.add((0, ScheduleRow_1.scheduleRowRef)("".concat(newRow.id, "-").concat(newRow.isProposed)));
                                        }
                                    }
                                });
                            }
                        }
                        if (entities.hasProposedSchedule) {
                            this.proposedDriverScheduleRows.clear();
                            this.setProposedDriverSchedule(entities);
                        }
                        else {
                            this.proposedDriverSchedule.clear();
                            this.setDriverSchedule(entities);
                        }
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchCompletedDriverSchedule = (0, mobx_keystone_1._async)(function (startDate, endDate, init) {
            var orderLegData, error_39, entities, error_40;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderLegData = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchCompletedOrderLegs(this.token, startDate, endDate)];
                    case 2:
                        (orderLegData = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_39 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_39)];
                    case 4:
                        orderLegData.forEach(function (data) {
                            var manifest = data.manifest, orderData = data.orderData, accessorialData = data.accessorialData, orderLeg = __rest(data, ["manifest", "orderData", "accessorialData"]);
                            if (manifest) {
                                if (_this.manifests.has("".concat(manifest.id))) {
                                    var oldManifest = _this.manifests.get("".concat(manifest.id));
                                    if (oldManifest) {
                                        oldManifest.update(manifest);
                                    }
                                }
                                else {
                                    var newManifest = Manifest_1.Manifest.create(_this, manifest);
                                    if (newManifest) {
                                        _this.manifests.set("".concat(newManifest.id), newManifest);
                                    }
                                }
                            }
                            if (orderData) {
                                _this.setLoad(orderData);
                            }
                            _this.setOrderLegs(orderLeg);
                            if (accessorialData) {
                                accessorialData.forEach(function (acc) { return _this.setAccessorial(acc); });
                            }
                        });
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, api.fetchCompletedDriverSchedule(this.token, startDate, endDate)];
                    case 6:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 8];
                    case 7:
                        error_40 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_40)];
                    case 8:
                        if (init) {
                            this.completedDriverScheduleRows.clear();
                        }
                        if (entities.rows) {
                            entities.rows.forEach(function (row) {
                                if (!!row.pickupStops.length || row.dropoffStops.length) {
                                    if (_this.completedDriverScheduleRows.has("".concat(row.id))) {
                                        var currentRow = _this.completedDriverScheduleRows.get("".concat(row.id));
                                        if (currentRow) {
                                            currentRow.update(row, false);
                                        }
                                    }
                                    else {
                                        var newRow = ScheduleRow_1.ScheduleRow.create(_this, row, false);
                                        if (newRow) {
                                            _this.completedDriverScheduleRows.set("".concat(newRow.id), newRow);
                                        }
                                    }
                                }
                            });
                        }
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchProposedDriverSchedule = (0, mobx_keystone_1._async)(function () {
            var response, error_41;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchProposedDriverSchedule(this.token)];
                    case 1:
                        response = _a.sent();
                        console.log('FETCH PROPOSED SCHEDULE RESPONSE:', response);
                        return [3 /*break*/, 3];
                    case 2:
                        error_41 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_41)];
                    case 3: 
                    // TODO: store schedule details
                    return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchScheduleRowWithOrderLeg = (0, mobx_keystone_1._async)(function (rowId) {
            var entities, error_42, proposedPickupOrderLegs, proposedDropoffOrderLegs, scheduleRow, row, newRow;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchScheduleRow(this.token, rowId)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_42 = _a.sent();
                        console.log('[DEBUG] error', error_42);
                        return [2 /*return*/, { error: error_42 }];
                    case 3:
                        proposedPickupOrderLegs = entities.proposedPickupOrderLegs, proposedDropoffOrderLegs = entities.proposedDropoffOrderLegs, scheduleRow = __rest(entities, ["proposedPickupOrderLegs", "proposedDropoffOrderLegs"]);
                        if (proposedPickupOrderLegs.length) {
                            proposedPickupOrderLegs.forEach(function (orderLeg) { return _this.setOrderLegs(orderLeg); });
                        }
                        if (proposedDropoffOrderLegs.length) {
                            proposedDropoffOrderLegs.forEach(function (orderLeg) { return _this.setOrderLegs(orderLeg); });
                        }
                        if (this.driverScheduleRows.has("".concat(scheduleRow.id))) {
                            row = this.driverScheduleRows.get("".concat(scheduleRow.id));
                            if (row) {
                                row.update(scheduleRow, false);
                            }
                            else {
                                newRow = ScheduleRow_1.ScheduleRow.create(this, scheduleRow, false);
                                if (newRow) {
                                    this.driverScheduleRows.set("".concat(newRow.id), newRow);
                                }
                            }
                        }
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchDriverScheduleOrderLegs = (0, mobx_keystone_1._async)(function () {
            var entities, error_43;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchDriverScheduleOrderLegs(this.token)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_43 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_43)];
                    case 4:
                        entities.forEach(function (data) {
                            var manifest = data.manifest, orderData = data.orderData, accessorialData = data.accessorialData, orderLeg = __rest(data, ["manifest", "orderData", "accessorialData"]);
                            if (manifest) {
                                if (_this.manifests.has("".concat(manifest.id))) {
                                    var oldManifest = _this.manifests.get("".concat(manifest.id));
                                    if (oldManifest) {
                                        oldManifest.update(manifest);
                                    }
                                }
                                else {
                                    var newManifest = Manifest_1.Manifest.create(_this, manifest);
                                    if (newManifest) {
                                        _this.manifests.set("".concat(newManifest.id), newManifest);
                                    }
                                }
                            }
                            if (orderData) {
                                _this.setLoad(orderData);
                            }
                            _this.setOrderLegs(orderLeg);
                            if (accessorialData) {
                                accessorialData.forEach(function (acc) { return _this.setAccessorial(acc); });
                            }
                        });
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.acceptProposedSchedule = (0, mobx_keystone_1._async)(function () {
            var response, error_44;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.activeScheduleId) return [3 /*break*/, 2];
                        return [4 /*yield*/, api.acceptProposedSchedule(this.token, this.activeScheduleId)];
                    case 1:
                        response = _a.sent();
                        console.log('[DEBUG] ACCEPT PROPOSED SCHEDULE RESPONSE', response);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_44 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_44)];
                    case 4:
                        // this.driverScheduleRows.clear();
                        this.proposedDriverScheduleRows.clear();
                        this.driverSchedule.clear();
                        this.proposedDriverSchedule.clear();
                        return [4 /*yield*/, this.fetchActiveDriverSchedule()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.fetchDriverScheduleOrderLegs()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.rejectProposedSchedule = (0, mobx_keystone_1._async)(function (reason) {
            var response, error_45;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this.activeScheduleId) return [3 /*break*/, 2];
                        return [4 /*yield*/, api.rejectProposedSchedule(this.token, this.activeScheduleId, reason)];
                    case 1:
                        response = _a.sent();
                        console.log('[DEBUG] REJECT PROPOSED SCHEDULE RESPONSE', response);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_45 = _a.sent();
                        console.log('[DEBUG] error', error_45);
                        return [2 /*return*/, { error: error_45 }];
                    case 4:
                        this.driverScheduleRows.clear();
                        this.proposedDriverScheduleRows.clear();
                        this.driverSchedule.clear();
                        this.proposedDriverSchedule.clear();
                        return [4 /*yield*/, this.fetchActiveDriverSchedule()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.fetchDriverScheduleOrderLegs()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchOrderLegs = (0, mobx_keystone_1._async)(function (query, statuses, url, replace) {
            var entities, error_46, next, orderLegs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = {
                            next: null,
                            results: [],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLoads(this.token, (0, LoadQuery_1.toAPI)(__assign({ offset: '0', status__in: statuses }, query)), url)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_46 = _a.sent();
                        console.log('[DEBUG] error', error_46);
                        return [3 /*break*/, 4];
                    case 4:
                        next = entities.next, orderLegs = entities.results;
                        if (replace) {
                            this.orderlegs.clear();
                        }
                        // This will pase the `this` to setLoad as well.
                        return [2 /*return*/, {
                                orderLegs: orderLegs.map(function (data) {
                                    var manifest = data.manifest, orderData = data.orderData, orderLeg = __rest(data, ["manifest", "orderData"]);
                                    if (manifest) {
                                        if (_this.manifests.has("".concat(manifest.id))) {
                                            var oldManifest = _this.manifests.get("".concat(manifest.id));
                                            if (oldManifest) {
                                                oldManifest.update(manifest);
                                            }
                                        }
                                        else {
                                            var newManifest = Manifest_1.Manifest.create(_this, manifest);
                                            if (newManifest) {
                                                _this.manifests.set("".concat(newManifest.id), newManifest);
                                            }
                                        }
                                    }
                                    if (orderData) {
                                        _this.setLoad(orderData);
                                    }
                                    return _this.setOrderLegs(orderLeg);
                                }),
                                next: next,
                            }];
                }
            });
        });
        _this.fetchLoadTableRows = (0, mobx_keystone_1._async)(function (query, statuses, url, replace) {
            var entities, error_47, count, next, loads;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = {
                            count: 0,
                            next: null,
                            results: [],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLoadTableRows(this.token, (0, LoadQuery_1.toAPI)(__assign({ limit: "".concat(load_1.TABLE_ROW_FETCH_LIMIT), offset: '0', status__in: statuses }, query)), url)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_47 = _a.sent();
                        console.log('[DEBUG] error', error_47);
                        return [3 /*break*/, 4];
                    case 4:
                        count = entities.count, next = entities.next, loads = entities.results;
                        if (replace) {
                            this.loadTableRows.clear();
                        }
                        // This will pase the `this` to setLoad as well.
                        return [2 /*return*/, {
                                count: count,
                                loads: loads.map(function (data) { return _this.setLoadTableRow(data); }),
                                next: next,
                            }];
                }
            });
        });
        _this.fetchAdditionalBillingTableRows = (0, mobx_keystone_1._async)(function (query, statuses, url, replace) {
            var entities, error_48, count, next, loads;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = {
                            count: 0,
                            next: null,
                            results: [],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchAdditionalBillingTableRows(this.token, (0, LoadQuery_1.toAPI)(__assign({ limit: "".concat(load_1.TABLE_ROW_FETCH_LIMIT), offset: '0', status__in: statuses }, query)), url)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_48 = _a.sent();
                        console.log('[DEBUG] error', error_48);
                        return [3 /*break*/, 4];
                    case 4:
                        count = entities.count, next = entities.next, loads = entities.results;
                        if (replace) {
                            this.loadTableRows.clear();
                        }
                        return [2 /*return*/, {
                                count: count,
                                loads: loads.map(function (data) { return _this.setLoadTableRow(data); }),
                                next: next,
                            }];
                }
            });
        });
        _this.fetchVisibleTableRows = (0, mobx_keystone_1._async)(function (query, statuses, url, offset) {
            var entities, error_49, count, next, visibleIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = {
                            count: 0,
                            next: null,
                            results: [],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchVisibleTableRows(this.token, (0, LoadQuery_1.toAPI)(__assign({ limit: "".concat(load_1.VISIBLE_ID_FETCH_LIMIT), offset: offset ? offset : '0', status__in: statuses }, query)), url)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_49 = _a.sent();
                        console.log('[DEBUG] error', error_49);
                        return [3 /*break*/, 4];
                    case 4:
                        count = entities.count, next = entities.next, visibleIds = entities.results;
                        return [2 /*return*/, {
                                visibleIds: visibleIds,
                                next: next,
                                count: count,
                            }];
                }
            });
        });
        _this.fetchTruck = (0, mobx_keystone_1._async)(function (id) {
            var data, error_50, truck;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchTruck(this.token, id, this.orderLegLinkId)];
                    case 1:
                        (data = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_50 = _a.sent();
                        console.log('[DEBUG] error', error_50);
                        return [2 /*return*/];
                    case 3:
                        try {
                            truck = data;
                            if (data.vehicleType) {
                                if (!this.trucks.has("".concat(data.vehicleType))) {
                                    if (typeof data.vehicleType === 'number')
                                        this.fetchVehicleType(data.vehicleType);
                                }
                                truck.vehicleType = (0, VehicleType_1.vehicleTypeRef)("".concat(data.vehicleType));
                            }
                            if (data.terminal) {
                                if (!this.locations.has("".concat(data.terminal))) {
                                    this.fetchLocation(data.terminal);
                                }
                                truck.terminal = (0, Location_1.locationRef)("".concat(data.terminal));
                            }
                            this.trucks.set("".concat(truck.id), new Truck_1.Truck(truck));
                        }
                        catch (error) {
                            console.log('[DEBUG] error', error);
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchVehicleType = (0, mobx_keystone_1._async)(function (id) {
            var data, error_51;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchVehicleType(this.token, id, this.orderLegLinkId)];
                    case 1:
                        (data = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_51 = _a.sent();
                        console.log('[DEBUG] error', error_51);
                        return [2 /*return*/];
                    case 3:
                        this.vehicleTypes.set("".concat(data.id), new VehicleType_1.VehicleType(data));
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchLocation = (0, mobx_keystone_1._async)(function (id) {
            var entities, error_52, location_2, location_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchLocation(this.token, id, this.orderLegLinkId)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_52 = _a.sent();
                        console.log('[DEBUG] error', error_52);
                        return [2 /*return*/];
                    case 3:
                        if (!this.locations.has("".concat(entities.id))) {
                            try {
                                location_2 = new Location_1.Location(entities);
                                this.locations.set("".concat(location_2.id), location_2);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                                return [2 /*return*/];
                            }
                        }
                        else {
                            location_3 = this.locations.get("".concat(entities.id));
                            if (location_3) {
                                location_3.update(entities);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchTerminalLocations = (0, mobx_keystone_1._async)(function () {
            var entities, queryString, error_53;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        queryString = { is_four_star_terminal: 'true' };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLocations(this.token, queryString, this.orderLegLinkId)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_53 = _a.sent();
                        console.log('[DEBUG] error', error_53);
                        return [2 /*return*/];
                    case 4:
                        entities.forEach(function (data) {
                            try {
                                var location_4 = new Location_1.Location(data);
                                _this.locations.set("".concat(location_4.id), location_4);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                                return;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchSiteLocationNames = (0, mobx_keystone_1._async)(function (name) {
            var entities, queryString, error_54;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        queryString = {
                            name__icontains: name,
                            location_type: location_1.LOCATION_TYPE.SITE,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLocationNames(this.token, queryString, this.orderLegLinkId)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_54 = _a.sent();
                        console.log('[DEBUG] error', error_54);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/, entities];
                }
            });
        });
        _this.fetchLocationAddressData = (0, mobx_keystone_1._async)(function (name) {
            var entities, queryString, error_55;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        queryString = {
                            name__iexact: name,
                            location_type: location_1.LOCATION_TYPE.SITE,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLocations(this.token, queryString, this.orderLegLinkId)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_55 = _a.sent();
                        console.log('[DEBUG] error', error_55);
                        return [3 /*break*/, 4];
                    case 4:
                        if (entities.length > 0) {
                            return [2 /*return*/, (0, Location_1.getLocationAddressData)(entities[0])];
                        }
                        return [2 /*return*/, (0, Location_1.getLocationAddressData)(null)];
                }
            });
        });
        _this.fetchLoadTypes = (0, mobx_keystone_1._async)(function () {
            var entities, error_56;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLoadTypes(this.token)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_56 = _a.sent();
                        console.log('[DEBUG] error', error_56);
                        return [2 /*return*/];
                    case 4:
                        entities.forEach(function (data) {
                            try {
                                var loadType = new LoadType_1.LoadType(data);
                                _this.loadTypes.set("".concat(loadType.id), loadType);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                                return;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchLoadUnits = (0, mobx_keystone_1._async)(function () {
            var entities, error_57;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchLoadUnits(this.token)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_57 = _a.sent();
                        console.log('[DEBUG] error', error_57);
                        return [2 /*return*/];
                    case 4:
                        entities.forEach(function (data) {
                            try {
                                var loadUnit = new LoadUnit_1.LoadUnit(data);
                                _this.loadUnits.set("".concat(loadUnit.id), loadUnit);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                                return;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchOrganizations = (0, mobx_keystone_1._async)(function () {
            var entities, error_58;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchOrganizations(this.token)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_58 = _a.sent();
                        console.log('[DEBUG] error', error_58);
                        return [2 /*return*/];
                    case 4:
                        entities.forEach(function (data) {
                            try {
                                var organization = new Organization_1.Organization(data);
                                _this.organizations.set("".concat(organization.id), organization);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                                return;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchOrganization = (0, mobx_keystone_1._async)(function (id) {
            var entities, error_59, organization;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchOrganization(this.token, id)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_59 = _a.sent();
                        console.log('[DEBUG] error', error_59);
                        return [2 /*return*/];
                    case 3:
                        if (!this.organizations.has("".concat(entities.id))) {
                            try {
                                organization = new Organization_1.Organization(entities);
                                this.organizations.set("".concat(organization.id), organization);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                                return [2 /*return*/];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
        _this.fetchUser = (0, mobx_keystone_1._async)(function (username) {
            var data, error_60;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchUser(this.token, username, this.orderLegLinkId)];
                    case 1:
                        (data = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_60 = _a.sent();
                        console.log('[DEBUG] error', error_60);
                        return [2 /*return*/];
                    case 3: return [4 /*yield*/, this.setUser(data)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
        _this.setUser = (0, mobx_keystone_1._async)(function (data) {
            var user, newUser, error_61;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = __assign({}, data);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!data.organization) return [3 /*break*/, 4];
                        if (!!this.organizations.has("".concat(data.organization))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchOrganization(data.organization)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        user.organization = (0, Organization_1.organizationRef)("".concat(data.organization));
                        _a.label = 4;
                    case 4:
                        newUser = new User_1.User(user);
                        this.users.set(user.username, newUser);
                        return [3 /*break*/, 6];
                    case 5:
                        error_61 = _a.sent();
                        console.log('[DEBUG] error', error_61);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
        _this.fetchDrivers = (0, mobx_keystone_1._async)(function (url) {
            var entities, error_62, next, results;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = {
                            next: null,
                            results: [],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchDrivers(this.token, url)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_62 = _a.sent();
                        console.log('[DEBUG] error', error_62);
                        return [2 /*return*/];
                    case 4:
                        next = entities.next, results = entities.results;
                        results.forEach(function (data) {
                            try {
                                _this.setUser(data);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                                return;
                            }
                        });
                        return [2 /*return*/, next];
                }
            });
        });
        _this.fetchManifest = (0, mobx_keystone_1._async)(function (id) {
            var entities, error_63, orders, orderLegsData, billingLegs, accessorials, manifestData, manifest;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchManifest(this.token, id, this.manifestLinkId)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_63 = _a.sent();
                        console.log('[DEBUG] error', error_63);
                        return [2 /*return*/];
                    case 3:
                        orders = entities.orders, orderLegsData = entities.orderLegsData, billingLegs = entities.billingLegs, accessorials = entities.accessorials, manifestData = __rest(entities, ["orders", "orderLegsData", "billingLegs", "accessorials"]);
                        manifest = this.setManifest(manifestData);
                        orders.forEach(function (orderData) {
                            _this.setLoad(orderData);
                        });
                        orderLegsData.forEach(function (orderLegData) {
                            _this.setOrderLegs(orderLegData);
                        });
                        billingLegs.forEach(function (billingData) {
                            _this.setBilling(billingData);
                        });
                        accessorials.forEach(function (accessorialData) {
                            _this.setAccessorial(accessorialData);
                        });
                        return [2 /*return*/, {
                                loads: orderLegsData.map(function (data) { return _this.orderlegs.get("".concat(data.id)); }),
                                ok: true,
                                manifest: manifest,
                                orders: orders.map(function (data) { return _this.loads.get("".concat(data.id)); }),
                                billings: billingLegs.map(function (data) { return _this.billings.get("".concat(data.id)); }),
                                accessorials: accessorials.map(function (data) {
                                    return _this.accessorials.get("".concat(data.id));
                                }),
                            }];
                }
            });
        });
        _this.createManifestLoads = (0, mobx_keystone_1._async)(function (data) {
            var entities, error_64, orders, orderLegsData, billingLegs, accessorials, manifestData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.createManifestLoads(this.token, data)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_64 = _a.sent();
                        console.log('[DEBUG] error', error_64);
                        return [2 /*return*/, (0, models_1.getError)(error_64)];
                    case 3:
                        orders = entities.orders, orderLegsData = entities.orderLegsData, billingLegs = entities.billingLegs, accessorials = entities.accessorials, manifestData = __rest(entities, ["orders", "orderLegsData", "billingLegs", "accessorials"]);
                        this.setManifest(manifestData);
                        orders.forEach(function (orderData) {
                            _this.setLoad(orderData);
                        });
                        orderLegsData.forEach(function (orderLegData) {
                            _this.setOrderLegs(orderLegData);
                        });
                        billingLegs.forEach(function (billingData) {
                            _this.setBilling(billingData);
                        });
                        accessorials.forEach(function (accessorialData) {
                            _this.setAccessorial(accessorialData);
                        });
                        return [2 /*return*/, {
                                loads: orderLegsData.map(function (data) { return _this.orderlegs.get("".concat(data.id)); }),
                                orders: orders.map(function (data) { return _this.loads.get("".concat(data.id)); }),
                                ok: true,
                            }];
                }
            });
        });
        _this.updateManifestLoads = (0, mobx_keystone_1._async)(function (data) {
            var entities, error_65, orders, orderLegsData, billingLegs, accessorials, manifestData, manifest;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.updateManifestLoads(this.token, data)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_65 = _a.sent();
                        console.log('[DEBUG] error', error_65);
                        return [2 /*return*/, (0, models_1.getError)(error_65)];
                    case 3:
                        orders = entities.orders, orderLegsData = entities.orderLegsData, billingLegs = entities.billingLegs, accessorials = entities.accessorials, manifestData = __rest(entities, ["orders", "orderLegsData", "billingLegs", "accessorials"]);
                        manifest = this.setManifest(manifestData);
                        orders.forEach(function (orderData) {
                            _this.setLoad(orderData);
                        });
                        orderLegsData.forEach(function (orderLegData) {
                            _this.setOrderLegs(orderLegData);
                        });
                        billingLegs.forEach(function (billingData) {
                            _this.setBilling(billingData);
                        });
                        accessorials.forEach(function (accessorialData) {
                            _this.setAccessorial(accessorialData);
                        });
                        return [2 /*return*/, {
                                loads: orderLegsData.map(function (data) { return _this.orderlegs.get("".concat(data.id)); }),
                                orders: orders.map(function (data) { return _this.loads.get("".concat(data.id)); }),
                                manifest: manifest,
                                ok: true,
                            }];
                }
            });
        });
        _this.rotatePhotoRight = (0, mobx_keystone_1._async)(function (id) {
            var error_66;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.rotatePhotoRight(this.token, "".concat(id))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_66 = _a.sent();
                        console.log('[DEBUG] error', error_66);
                        return [2 /*return*/, (0, models_1.getError)(error_66)];
                    case 3: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchNotifications = (0, mobx_keystone_1._async)(function (query) {
            var responseData, res, error_67, results, count;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchNotifications(this.token, query)];
                    case 1:
                        res = _b.sent();
                        responseData = res.response.entities;
                        return [3 /*break*/, 3];
                    case 2:
                        error_67 = _b.sent();
                        console.log('[DEBUG] error', error_67);
                        return [2 /*return*/, { count: 0 }];
                    case 3:
                        results = responseData.results || responseData || [];
                        count = (_a = responseData.count) !== null && _a !== void 0 ? _a : results.length;
                        this.notifications.clear();
                        results.forEach(function (data) {
                            try {
                                var notification = new Notification_1.Notification(data);
                                _this.notifications.set("".concat(notification.id), notification);
                            }
                            catch (error) {
                                console.log('[DEBUG] error', error);
                            }
                        });
                        return [2 /*return*/, { count: count }];
                }
            });
        });
        _this.fetchUnreadNotificationCount = (0, mobx_keystone_1._async)(function () {
            var entities, error_68;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchUnreadNotificationCount(this.token)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_68 = _a.sent();
                        console.log('[DEBUG] error', error_68);
                        return [2 /*return*/, (0, models_1.getError)(error_68)];
                    case 3:
                        this.unreadNotificationCount = entities.unreadCount;
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.bulkNotificationRead = (0, mobx_keystone_1._async)(function () {
            var error_69;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.bulkMarkNotificationsAsRead(this.token)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_69 = _a.sent();
                        console.log('[DEBUG] error', error_69);
                        return [2 /*return*/, (0, models_1.getError)(error_69)];
                    case 3:
                        this.unreadNotificationCount = 0;
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.bulkNotificationDelete = (0, mobx_keystone_1._async)(function () {
            var error_70;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.bulkNotificationDelete(this.token)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_70 = _a.sent();
                        console.log('[DEBUG] error', error_70);
                        return [2 /*return*/, (0, models_1.getError)(error_70)];
                    case 3:
                        this.unreadNotificationCount = 0;
                        this.notifications.clear();
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.updateNotificationRead = (0, mobx_keystone_1._async)(function (id, isRead) {
            var notification, error_71;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, api.updateNotificationRead(this.token, id, isRead)];
                    case 1:
                        _a.sent();
                        notification = this.notifications.get("".concat(id));
                        if (notification) {
                            notification.setIsRead(isRead);
                        }
                        return [4 /*yield*/, this.fetchUnreadNotificationCount()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_71 = _a.sent();
                        console.log('[DEBUG] error', error_71);
                        return [2 /*return*/, (0, models_1.getError)(error_71)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.createLoadReport = (0, mobx_keystone_1._async)(function (data) {
            var entities, error_72, orderleg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.createLoadReport(this.token, data)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_72 = _a.sent();
                        console.log('[DEBUG] error', error_72);
                        return [2 /*return*/, (0, models_1.getError)(error_72)];
                    case 3:
                        orderleg = this.orderlegs.get("".concat(entities.leg));
                        orderleg === null || orderleg === void 0 ? void 0 : orderleg.setReport(entities);
                        return [2 /*return*/, entities];
                }
            });
        });
        _this.updateLoadReport = (0, mobx_keystone_1._async)(function (id, data) {
            var entities, error_73, orderleg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.updateLoadReport(this.token, id, data)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_73 = _a.sent();
                        console.log('[DEBUG] error', error_73);
                        return [2 /*return*/, (0, models_1.getError)(error_73)];
                    case 3:
                        orderleg = this.orderlegs.get("".concat(entities.leg));
                        orderleg === null || orderleg === void 0 ? void 0 : orderleg.setReport(entities);
                        return [2 /*return*/, entities];
                }
            });
        });
        _this.createEquipmentReport = (0, mobx_keystone_1._async)(function () {
            var entities, error_74;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.createEquipmentReport(this.token)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_74 = _a.sent();
                        console.log('[DEBUG] error', error_74);
                        return [2 /*return*/, (0, models_1.getError)(error_74)];
                    case 3:
                        this.equipmentReport = new EquipmentDamageReport_1.EquipmentDamageReport({
                            id: entities.id,
                            driver: entities.driver,
                            type: entities.type,
                            notes: entities.notes,
                            unitNumber: entities.unitNumber,
                            isDraft: entities.isDraft,
                            photos: [],
                        });
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.sendEquipmentReport = (0, mobx_keystone_1._async)(function (data) {
            var entities, error_75;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.sendEquipmentReport(this.token, data)];
                    case 1:
                        (entities = (_b.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_75 = _b.sent();
                        console.log('[DEBUG] error', error_75);
                        return [2 /*return*/, (0, models_1.getError)(error_75)];
                    case 3:
                        (_a = this.equipmentReport) === null || _a === void 0 ? void 0 : _a.setIsDraft(false);
                        return [2 /*return*/, entities];
                }
            });
        });
        _this.fetchLoadReport = (0, mobx_keystone_1._async)(function (id) {
            var entities, error_76;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchDriverLoadReport(this.token, id)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_76 = _a.sent();
                        console.log('[DEBUG] error', error_76);
                        return [2 /*return*/, (0, models_1.getError)(error_76)];
                    case 3: return [2 /*return*/, entities];
                }
            });
        });
        _this.fetchUserLoadReports = (0, mobx_keystone_1._async)(function () {
            var entities, error_77;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchDriverLoadUserReports(this.token)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_77 = _a.sent();
                        console.log('[DEBUG] error', error_77);
                        return [2 /*return*/, (0, models_1.getError)(error_77)];
                    case 3: return [2 /*return*/, entities];
                }
            });
        });
        _this.createDriverLoadReport = (0, mobx_keystone_1._async)(function () {
            var entities, error_78;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.createDriverLoadReport(this.token)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_78 = _a.sent();
                        console.log('[DEBUG] error', error_78);
                        return [2 /*return*/, (0, models_1.getError)(error_78)];
                    case 3:
                        this.driverLoadReport = new DriverLoadReport_1.DriverLoadReport({
                            id: entities.id,
                            driver: entities.driver,
                            as400ManifestNumber: entities.as400ManifestNumber,
                            notes: entities.notes,
                            isDraft: entities.isDraft,
                            photos: [],
                            documents: [],
                        });
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.sendDriverLoadReport = (0, mobx_keystone_1._async)(function (data) {
            var error_79;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.sendDriverLoadReport(this.token, data)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_79 = _b.sent();
                        console.log('[DEBUG] error', error_79);
                        return [2 /*return*/, (0, models_1.getError)(error_79)];
                    case 3:
                        (_a = this.driverLoadReport) === null || _a === void 0 ? void 0 : _a.setIsDraft(false);
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.createPhotoIssueReport = (0, mobx_keystone_1._async)(function (legId) {
            var entities, error_80, photoIssueReport;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.createPhotoIssueReport(this.token, legId)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_80 = _a.sent();
                        console.log('[DEBUG] error', error_80);
                        return [2 /*return*/, { ok: true, data: error_80 }];
                    case 3:
                        photoIssueReport = new PhotoIssueReport_1.PhotoIssueReport(__assign({}, entities));
                        return [2 /*return*/, { ok: true, data: photoIssueReport }];
                }
            });
        });
        _this.updatePhotoIssueReport = (0, mobx_keystone_1._async)(function (id, data) {
            var entities, error_81, photoIssueReport;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.updatePhotoIssueReport(this.token, id, data)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_81 = _a.sent();
                        console.log('[DEBUG] error', error_81);
                        return [2 /*return*/, (0, models_1.getError)(error_81)];
                    case 3:
                        photoIssueReport = new PhotoIssueReport_1.PhotoIssueReport(__assign({}, entities));
                        return [2 /*return*/, { ok: true, data: photoIssueReport }];
                }
            });
        });
        _this.fetchPermits = (0, mobx_keystone_1._async)(function () {
            var entities, error_82;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entities = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.fetchPermits(this.token)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_82 = _a.sent();
                        console.log('[DEBUG] error', error_82);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/, entities];
                }
            });
        });
        _this.createAdditionalBillingDocument = (0, mobx_keystone_1._async)(function (additionalBillingLegId, documentType) {
            var result, error_83;
            if (documentType === void 0) { documentType = 'additional_billing'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.createAdditionalBillingDocumentWeb(this.token, additionalBillingLegId, documentType)];
                    case 2:
                        (result = (_a.sent()).response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_83 = _a.sent();
                        console.log('[DEBUG] error creating additional billing document', error_83);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
        _this.addAdditionalBillingPhotos = (0, mobx_keystone_1._async)(function (documentId, photos) {
            var result, error_84;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.createAdditionalBillingDocumentPhotosWeb(this.token, documentId, photos)];
                    case 2:
                        (result = (_a.sent()).response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_84 = _a.sent();
                        console.log('[DEBUG] error uploading additional billing photos', error_84);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
        _this.addAdditionalBillingFiles = (0, mobx_keystone_1._async)(function (documentId, files) {
            var result, error_85;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.createAdditionalBillingDocumentFilesWeb(this.token, documentId, files)];
                    case 2:
                        (result = (_a.sent()).response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_85 = _a.sent();
                        console.log('[DEBUG] error uploading additional billing files', error_85);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
        _this.deleteAdditionalBillingPhoto = (0, mobx_keystone_1._async)(function (documentId, photoId) {
            var result, error_86;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, (0, models_1.getError)(new Error('No token'))];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.deleteAdditionalBillingDocumentPhotosWeb(this.token, documentId, [photoId])];
                    case 2:
                        (result = (_a.sent()).response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_86 = _a.sent();
                        console.log('[DEBUG] error deleting additional billing photo', error_86);
                        return [2 /*return*/, (0, models_1.getError)(error_86)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.deleteAdditionalBillingFile = (0, mobx_keystone_1._async)(function (documentId, fileId) {
            var result, error_87;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, (0, models_1.getError)(new Error('No token'))];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.deleteAdditionalBillingDocumentFilesWeb(this.token, documentId, [fileId])];
                    case 2:
                        (result = (_a.sent()).response);
                        return [3 /*break*/, 4];
                    case 3:
                        error_87 = _a.sent();
                        console.log('[DEBUG] error deleting additional billing file', error_87);
                        return [2 /*return*/, (0, models_1.getError)(error_87)];
                    case 4: return [2 /*return*/, (0, models_1.getSuccess)()];
                }
            });
        });
        _this.fetchAdditionalBillingLeg = (0, mobx_keystone_1._async)(function (id) {
            var entities, error_88, leg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.fetchAdditionalBillingLeg(this.token, id)];
                    case 1:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 3];
                    case 2:
                        error_88 = _a.sent();
                        console.log('[DEBUG] error', error_88);
                        return [2 /*return*/, []];
                    case 3:
                        leg = this.setAdditionalBillingLeg(entities);
                        return [2 /*return*/, { ok: true, data: leg }];
                }
            });
        });
        _this.createAdditionalBillingLeg = (0, mobx_keystone_1._async)(function (data) {
            var entities, error_89, leg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, (0, models_1.getError)(new Error('No authentication token'))];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.createAdditionalBillingLeg(this.token, data)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_89 = _a.sent();
                        console.log('[DEBUG] error creating additional billing leg', error_89);
                        return [2 /*return*/, (0, models_1.getError)(error_89)];
                    case 4:
                        leg = this.setAdditionalBillingLeg(entities);
                        return [2 /*return*/, { ok: true, data: leg }];
                }
            });
        });
        _this.updateAdditionalBillingLeg = (0, mobx_keystone_1._async)(function (id, data) {
            var entities, error_90, leg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, (0, models_1.getError)(new Error('No authentication token'))];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.updateAdditionalBillingLeg(this.token, id, data)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_90 = _a.sent();
                        console.log('[DEBUG] error updating additional billing leg', error_90);
                        return [2 /*return*/, (0, models_1.getError)(error_90)];
                    case 4:
                        leg = this.setAdditionalBillingLeg(entities);
                        return [2 /*return*/, { ok: true, data: leg }];
                }
            });
        });
        _this.dispatcherUpdateLoadStatus = (0, mobx_keystone_1._async)(function (loadId, data) {
            var response, error_91;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, (0, models_1.getError)(new Error('No token'))];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.dispatcherUpdateLoadStatus(this.token, loadId, data)];
                    case 2:
                        response = (_a.sent()).response;
                        if (response === null || response === void 0 ? void 0 : response.entities) {
                            if (Array.isArray(response.entities)) {
                                response.entities.forEach(function (item) { return _this.setLoadTableRow(item); });
                            }
                            else {
                                this.setLoadTableRow(response.entities);
                            }
                        }
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                    case 3:
                        error_91 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_91)];
                    case 4: return [2 /*return*/];
                }
            });
        });
        _this.dispatcherUpdateAdditionalBillingStatus = (0, mobx_keystone_1._async)(function (id, data) {
            var response, error_92;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token)
                            return [2 /*return*/, (0, models_1.getError)(new Error('No token'))];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.dispatcherUpdateAdditionalBillingStatus(this.token, id, data)];
                    case 2:
                        response = (_a.sent()).response;
                        if (response === null || response === void 0 ? void 0 : response.entities) {
                            this.setLoadTableRow(response.entities);
                        }
                        return [2 /*return*/, (0, models_1.getSuccess)()];
                    case 3:
                        error_92 = _a.sent();
                        return [2 /*return*/, (0, models_1.getError)(error_92)];
                    case 4: return [2 /*return*/];
                }
            });
        });
        return _this;
    }
    Object.defineProperty(RootStore.prototype, "activeLoad", {
        get: function () {
            var _this = this;
            return Array.from(this.orderlegs.values()).find(function (load) {
                var me = _this.me && _this.me.maybeCurrent;
                if (load.driver && load.driver.maybeCurrent !== me) {
                    return false;
                }
                return load.isActive;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "activeSchedule", {
        // @computed
        // get activeScheduleStop(): ScheduleRow | undefined {
        //   return Array.from(this.driverScheduleRows.values()).find(scheduleRow => {
        //     const me = this.me && this.me.maybeCurrent;
        //     // TODO: Add condition to determine active stop
        //   });
        // }
        get: function () {
            var _this = this;
            var ret = Array.from(this.driverSchedule.values()).find(function (driverSchedule) {
                return driverSchedule.id === _this.activeScheduleId;
            });
            return !!ret
                ? ret
                : new DriverSchedule_1.DriverSchedule({
                    id: 0,
                    driver: null,
                    hasProposedSchedule: false,
                });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "proposedSchedule", {
        get: function () {
            var _this = this;
            var ret = Array.from(this.proposedDriverSchedule.values()).find(function (driverSchedule) {
                return driverSchedule.id === _this.activeScheduleId;
            });
            return !!ret
                ? ret
                : new DriverSchedule_1.DriverSchedule({
                    id: 0,
                    driver: null,
                    hasProposedSchedule: false,
                    forceUpdate: false,
                });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "isForceAccept", {
        get: function () {
            return this.proposedSchedule.forceUpdate;
        },
        enumerable: false,
        configurable: true
    });
    RootStore.prototype.setFirstGPS = function (firstGPS) {
        this.firstGPS = firstGPS;
    };
    //Will be Deleted
    RootStore.prototype.setManifest = function (data) {
        if (this.manifests.has("".concat(data.id))) {
            var manifest = this.manifests.get("".concat(data.id));
            if (manifest) {
                manifest.update(data);
            }
            return manifest;
        }
        else {
            var manifest = Manifest_1.Manifest.create(this, data);
            if (manifest) {
                this.manifests.set("".concat(manifest.id), manifest);
            }
            return manifest;
        }
    };
    RootStore.prototype.setBilling = function (data) {
        if (this.billings.has("".concat(data.id))) {
            var billing = this.billings.get("".concat(data.id));
            if (billing) {
                billing.update(data);
            }
            return billing;
        }
        else {
            var billing = Billing_1.Billing.create(this, data);
            if (billing) {
                this.billings.set("".concat(billing.id), billing);
            }
            return billing;
        }
    };
    RootStore.prototype.setAccessorial = function (data) {
        if (this.accessorials.has("".concat(data.id))) {
            var accessorial = this.accessorials.get("".concat(data.id));
            if (accessorial) {
                accessorial.update(data);
            }
            return accessorial;
        }
        else {
            var accessorial = Accessorial_1.LoadAccessorial.create(this, data);
            if (accessorial) {
                this.accessorials.set("".concat(accessorial.id), accessorial);
            }
            return accessorial;
        }
    };
    RootStore.prototype.setLoad = function (data, forceUpdate) {
        if (this.loads.has("".concat(data.id))) {
            var load = this.loads.get("".concat(data.id));
            if (load) {
                load.update(data, forceUpdate);
            }
            return load;
        }
        else {
            var load = Load_1.Load.create(this, data);
            if (load) {
                this.loads.set("".concat(load.id), load);
            }
            return load;
        }
    };
    RootStore.prototype.setDriverSchedule = function (data, forceUpdate) {
        if (this.driverSchedule.has("".concat(data.id))) {
            var driverSchedule = this.driverSchedule.get("".concat(data.id));
            if (driverSchedule) {
                driverSchedule.update(data, forceUpdate);
                this.setActiveScheduleId(driverSchedule.id);
            }
            return driverSchedule;
        }
        else {
            var driverSchedule = DriverSchedule_1.DriverSchedule.create(this, data);
            if (driverSchedule) {
                this.driverSchedule.set("".concat(driverSchedule.id), driverSchedule);
                this.setActiveScheduleId(driverSchedule.id);
            }
            return driverSchedule;
        }
    };
    RootStore.prototype.setProposedDriverSchedule = function (data, forceUpdate) {
        if (this.proposedDriverSchedule.has("".concat(data.id))) {
            var driverSchedule = this.proposedDriverSchedule.get("".concat(data.id));
            if (driverSchedule) {
                driverSchedule.update(data, forceUpdate);
                this.setActiveScheduleId(driverSchedule.id);
            }
            return driverSchedule;
        }
        else {
            var driverSchedule = DriverSchedule_1.DriverSchedule.create(this, data);
            if (driverSchedule) {
                this.proposedDriverSchedule.set("".concat(driverSchedule.id), driverSchedule);
                this.setActiveScheduleId(driverSchedule.id);
            }
            return driverSchedule;
        }
    };
    RootStore.prototype.setOrderLegs = function (data, forceUpdate) {
        if (this.orderlegs.has("".concat(data.id))) {
            var orderleg = this.orderlegs.get("".concat(data.id));
            if (orderleg) {
                orderleg.update(data, forceUpdate);
            }
            // console.log('set updated orderlegs:', orderleg);
            return orderleg;
        }
        else {
            var orderleg = OrderLeg_1.OrderLeg.create(this, data);
            if (orderleg) {
                this.orderlegs.set("".concat(orderleg.id), orderleg);
                orderleg.addPositionKeyToFirebase('initial'); //force create firebase folder
            }
            // console.log('set created orderlegs:', orderleg);
            return orderleg;
        }
    };
    RootStore.prototype.setLoadTableRow = function (data) {
        var _this = this;
        if (Array.isArray(data)) {
            return data.map(function (item) { return _this.setLoadTableRow(item); });
        }
        if (this.loadTableRows.has("".concat(data.id))) {
            var load = this.loadTableRows.get("".concat(data.id));
            if (load) {
                load.update(data);
            }
            return load;
        }
        else {
            var load = new LoadTableRow_1.LoadTableRow(data);
            if (load) {
                this.loadTableRows.set("".concat(load.id), load);
            }
            return load;
        }
    };
    RootStore.prototype.setAdditionalBillingLeg = function (data) {
        if (this.additionalBillingLegs.has("".concat(data.id))) {
            var leg = this.additionalBillingLegs.get("".concat(data.id));
            leg === null || leg === void 0 ? void 0 : leg.update(data);
            return leg;
        }
        else {
            var leg = AdditionalBillingLeg_1.AdditionalBillingLeg.create(data);
            this.additionalBillingLegs.set("".concat(leg.id), leg);
            return leg;
        }
    };
    RootStore.prototype.reset = function () {
        this.removeToken();
        this.driverSchedule.clear();
        this.proposedDriverSchedule.clear();
        // this.driverScheduleRows.clear();
        // this.proposedDriverScheduleRows.clear();
        this.completedDriverScheduleRows.clear();
        this.actions.clear();
        this.billings.clear();
        this.accessorials.clear();
        this.orderlegs.clear();
        this.loads.clear();
        this.manifests.clear();
        this.loadTableRows.clear();
        this.loadTypes.clear();
        this.loadUnits.clear();
        this.locations.clear();
        this.users.clear();
        this.tripLegs.clear();
        this.trucks.clear();
        this.organizations.clear();
        this.loadStops.clear();
        this.firstGPS = true;
        this.manifestLinkId = undefined;
        this.orderLegLinkId = undefined;
        this.currentDate = '';
        this.triggerSwipe = false;
        this.geofenceRadius = 100;
    };
    RootStore.prototype.resetOrderLegLinkId = function () {
        this.orderLegLinkId = undefined;
    };
    RootStore.prototype.resetManifestLinkId = function () {
        this.manifestLinkId = undefined;
    };
    RootStore.prototype.setUpdateLegId = function (id) {
        this.updateLegId = id;
    };
    RootStore.prototype.resetUpdateLegId = function () {
        this.updateLegId = undefined;
    };
    RootStore.prototype.setCopyLegId = function (id) {
        this.copyLegId = id;
    };
    RootStore.prototype.resetCopyLegId = function () {
        this.copyLegId = undefined;
    };
    RootStore.prototype.setUpdateLoadId = function (id) {
        this.updateLoadId = id;
    };
    RootStore.prototype.resetUpdateLoadId = function () {
        this.updateLoadId = undefined;
    };
    RootStore.prototype.setUpdateManifestId = function (id) {
        this.updateManifestId = id;
    };
    RootStore.prototype.resetUpdateManfestId = function () {
        this.updateManifestId = undefined;
    };
    RootStore.prototype.setUpdateBilling = function (id) {
        this.updateManifestId = id;
    };
    RootStore.prototype.resetUpdateManifestId = function () {
        this.updateManifestId = undefined;
    };
    RootStore.prototype.setUpdateAdditionalBillingId = function (id) {
        this.updateAdditionalBillingId = id;
    };
    RootStore.prototype.resetUpdateAdditionalBillingId = function () {
        this.updateAdditionalBillingId = undefined;
    };
    RootStore.prototype.setCopyLoadId = function (id) {
        this.copyLoadId = id;
    };
    RootStore.prototype.resetCopyLoadId = function () {
        this.copyLoadId = undefined;
    };
    RootStore.prototype.setActiveScheduleId = function (id) {
        this.activeScheduleId = id;
    };
    RootStore.prototype.setCopyManifestId = function (id) {
        this.copyManifestId = id;
    };
    RootStore.prototype.resetCopyManifestId = function () {
        this.copyManifestId = undefined;
    };
    RootStore.prototype.setGeofenceRadius = function (radius) {
        this.geofenceRadius = radius;
    };
    RootStore.prototype.setSafeMode = function (safeModeStatus) {
        this.safeMode = safeModeStatus;
    };
    RootStore.prototype.setUnreliableGPS = function (unreliableGPS) {
        this.unreliableGPS = unreliableGPS;
    };
    RootStore.prototype.setCurrentGPSPosition = function (position) {
        this.currentGPSPosition = position;
    };
    RootStore.prototype.setTriggerSwipe = function (triggerSwipe) {
        this.triggerSwipe = triggerSwipe;
    };
    RootStore.prototype.setPushNotificationToken = function (pushNotificationToken) {
        console.log('setting push notification called...');
        this.pushNotificationToken = pushNotificationToken;
    };
    Object.defineProperty(RootStore.prototype, "currentCoordinatesJson", {
        get: function () {
            var currentGPSPosition = this.currentGPSPosition;
            if (currentGPSPosition) {
                return {
                    type: 'Point',
                    coordinates: [
                        currentGPSPosition.longitude,
                        currentGPSPosition.latitude,
                    ],
                };
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "trackedLoad", {
        get: function () {
            var _this = this;
            var load = Array.from(this.loads.values()).find(function (load) { return load.manifestLinkId === _this.manifestLinkId; });
            console.log('[DEBUG][getLoadByManifestLinkId]', !!load && load.id);
            return load;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "trackedLeg", {
        get: function () {
            var _this = this;
            console.log('store orderleglinkid', this.orderLegLinkId);
            var orderLeg = Array.from(this.orderlegs.values()).find(function (orderLeg) { return orderLeg.orderLegLinkId === _this.orderLegLinkId; });
            console.log('[DEBUG][getLegByOrderLegLinkId] trackedLeg', !!orderLeg && orderLeg.id);
            return orderLeg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "trackedAllLegs", {
        get: function () {
            var _this = this;
            var orderLegLink = Array.from(this.orderlegs.values()).find(function (orderLeg) { return orderLeg.orderLegLinkId === _this.orderLegLinkId; });
            var allLegs = [];
            if (orderLegLink) {
                allLegs = Array.from(this.orderlegs.values()).filter(function (orderLeg) { return orderLeg.manifestId === orderLegLink.manifestId; });
            }
            return allLegs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "updatingLoad", {
        get: function () {
            var _this = this;
            var load = Array.from(this.loads.values()).find(function (load) { return load.id === _this.updateLoadId; });
            console.log('[DEBUG][getLoadByManifestLinkId]', !!load && load.id);
            return load;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "updatingManifest", {
        get: function () {
            var _this = this;
            var manifest = Array.from(this.manifests.values()).find(function (manifest) { return manifest.id === _this.updateManifestId; });
            console.log('[DEBUG][getManifestUpdate]', !!manifest && manifest.id);
            return manifest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "updatingLeg", {
        get: function () {
            var _this = this;
            var orderLeg = Array.from(this.orderlegs.values()).find(function (orderLeg) { return orderLeg.id === _this.updateLegId; });
            console.log('[DEBUG][getLegByOrderLegLinkIdUpdate] updatingLeg', !!orderLeg && orderLeg.id);
            return orderLeg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "copyingLoad", {
        get: function () {
            var _this = this;
            var load = Array.from(this.loads.values()).find(function (load) { return load.id === _this.copyLoadId; });
            console.log('[DEBUG][getLoadByManifestLinkId]', !!load && load.id);
            return load;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "copyingManifest", {
        get: function () {
            var _this = this;
            var manifest = Array.from(this.manifests.values()).find(function (manifest) { return manifest.id === _this.copyManifestId; });
            console.log('[DEBUG][getManifestCopy]', !!manifest && manifest.id);
            return manifest;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "activeLoad", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "activeSchedule", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "proposedSchedule", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "isForceAccept", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setFirstGPS", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setManifest", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setBilling", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setAccessorial", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setLoad", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setDriverSchedule", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setProposedDriverSchedule", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setOrderLegs", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setLoadTableRow", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setAdditionalBillingLeg", null);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "load", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "storeToken", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "removeToken", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "signup", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "validateOrganizationId", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "sendTwilioCode", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "verifyTwilioCode", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "login", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "loginWithFacebook", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "loginWithTwitter", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "loginWithGoogle", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchSocialAccounts", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "connectFacebook", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "connectTwitter", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "connectGoogle", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "verifyFirebaseToken", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "logout", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "changePassword", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "resetPasswordRequest", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "resetPasswordConfirm", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLoad", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchOrderLeg", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLoadByManifestLinkId", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchOrderLegByOrderLegLinkId", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchOrderLegByBillOfLading", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchAllOrderLegByOrderLegLinkId", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchAllOrderLegBillingLegByOrderLegLinkId", void 0);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetOrderLegLinkId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetManifestLinkId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setUpdateLegId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetUpdateLegId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setCopyLegId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetCopyLegId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setUpdateLoadId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetUpdateLoadId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setUpdateManifestId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetUpdateManfestId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setUpdateBilling", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetUpdateManifestId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setUpdateAdditionalBillingId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetUpdateAdditionalBillingId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setCopyLoadId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetCopyLoadId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setActiveScheduleId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setCopyManifestId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "resetCopyManifestId", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setGeofenceRadius", null);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchMe", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateMe", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateMePhoto", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "registerDriverDeviceToken", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "removeDeviceToken", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "getLatestAppVersion", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateLastActivity", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "getGeofenceRadius", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateScanCount", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "validateToken", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLoads", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchActiveDriverSchedule", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchCompletedDriverSchedule", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchProposedDriverSchedule", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchScheduleRowWithOrderLeg", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchDriverScheduleOrderLegs", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "acceptProposedSchedule", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "rejectProposedSchedule", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchOrderLegs", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLoadTableRows", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchAdditionalBillingTableRows", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchVisibleTableRows", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchTruck", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchVehicleType", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLocation", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchTerminalLocations", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchSiteLocationNames", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLocationAddressData", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLoadTypes", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLoadUnits", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchOrganizations", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchOrganization", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchUser", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "setUser", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchDrivers", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchManifest", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "createManifestLoads", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateManifestLoads", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "rotatePhotoRight", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchNotifications", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchUnreadNotificationCount", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "bulkNotificationRead", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "bulkNotificationDelete", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateNotificationRead", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "createLoadReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateLoadReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "createEquipmentReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "sendEquipmentReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchLoadReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchUserLoadReports", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "createDriverLoadReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "sendDriverLoadReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "createPhotoIssueReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updatePhotoIssueReport", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchPermits", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "createAdditionalBillingDocument", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "addAdditionalBillingPhotos", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "addAdditionalBillingFiles", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "deleteAdditionalBillingPhoto", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "deleteAdditionalBillingFile", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "fetchAdditionalBillingLeg", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "createAdditionalBillingLeg", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "updateAdditionalBillingLeg", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "dispatcherUpdateLoadStatus", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], RootStore.prototype, "dispatcherUpdateAdditionalBillingStatus", void 0);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setSafeMode", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setUnreliableGPS", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setCurrentGPSPosition", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setTriggerSwipe", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], RootStore.prototype, "setPushNotificationToken", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "currentCoordinatesJson", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "trackedLoad", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "trackedLeg", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "trackedAllLegs", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "updatingLoad", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "updatingManifest", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "updatingLeg", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "copyingLoad", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "copyingManifest", null);
    RootStore = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/RootStore')
    ], RootStore);
    return RootStore;
}((0, mobx_keystone_1.ExtendedModel)(BaseStore, {
    loading: (0, mobx_keystone_1.prop)(false),
    loaded: (0, mobx_keystone_1.prop)(false),
    firebaseToken: (0, mobx_keystone_1.prop)(),
    pushNotificationToken: (0, mobx_keystone_1.prop)(),
    me: (0, mobx_keystone_1.prop)(),
    actions: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    manifests: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    loads: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    orderlegs: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    additionalBillingLegs: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    loadTableRows: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    loadStops: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    loadTypes: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    loadUnits: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    locations: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    driverSchedule: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    driverScheduleRows: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    proposedDriverScheduleRows: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    proposedDriverSchedule: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    completedDriverScheduleRows: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    currentDate: (0, mobx_keystone_1.prop)(''),
    users: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    tripLegs: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    trucks: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    vehicleTypes: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    organizations: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    socialAccounts: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    billings: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    accessorials: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    notifications: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
    unreadNotificationCount: (0, mobx_keystone_1.prop)(0),
    safeMode: (0, mobx_keystone_1.prop)(false),
    unreliableGPS: (0, mobx_keystone_1.prop)(false),
    firstGPS: (0, mobx_keystone_1.prop)(true),
    currentGPSPosition: (0, mobx_keystone_1.prop)(),
    triggerSwipe: (0, mobx_keystone_1.prop)(false),
    geofenceRadius: (0, mobx_keystone_1.prop)(100),
    manifestLinkId: (0, mobx_keystone_1.prop)(),
    orderLegLinkId: (0, mobx_keystone_1.prop)(),
    updateLoadId: (0, mobx_keystone_1.prop)(),
    copyLoadId: (0, mobx_keystone_1.prop)(),
    updateLegId: (0, mobx_keystone_1.prop)(),
    copyLegId: (0, mobx_keystone_1.prop)(),
    updateAdditionalBillingId: (0, mobx_keystone_1.prop)(),
    activeScheduleId: (0, mobx_keystone_1.prop)(),
    updateManifestId: (0, mobx_keystone_1.prop)(),
    copyManifestId: (0, mobx_keystone_1.prop)(),
    equipmentReport: (0, mobx_keystone_1.prop)(),
    driverLoadReport: (0, mobx_keystone_1.prop)(),
    driverLoadReports: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.objectMap)(); }),
})));
exports.RootStore = RootStore;
exports.rootStoreRef = (0, mobx_keystone_1.rootRef)('doc-mate/RootStoreRef', {
    getId: function () { return 'RootStore'; },
});
var createRootStore = function () {
    var rootStore = new RootStore({});
    return rootStore;
};
exports.createRootStore = createRootStore;
exports.defaultRootStore = (0, exports.createRootStore)();
(0, mobx_keystone_1.registerRootStore)(exports.defaultRootStore);
